import { render, staticRenderFns } from "./SectionAgencyLegalInformationEmail.vue?vue&type=template&id=5253fd2d&"
import script from "./SectionAgencyLegalInformationEmail.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports